
import { useState } from "react";
import styled from "styled-components";
import { itemHistory, naira } from "../../../utils/data";
import { Input } from "../../../styles";
import { useDashboardContext } from "../../../context/dashboard_context";


const TopSellingStock = () => {


      const [load, setload] = useState(false);

      const { dashboardData } = useDashboardContext();

      const { topSell } = dashboardData;

      return (
            <StyledTopSellingStock className="h-100">
                  <div className="main-container">
                        <h4 className="mb-4 grey-bold-text">
                              Top Selling Stock
                        </h4>

                        <div className="light-bg br-md">

                              <div className="table-responsive">
                                    <table className='table p-2 border-0 text-center br-md' >
                                          <thead>
                                                <tr className=''>
                                                      <th scope="col" className='text-start grey-text'>
                                                            Name
                                                      </th>
                                                      <th scope="col" className='text-start grey-text'>
                                                            Price
                                                      </th>
                                                      <th scope="col" className='grey-text'>
                                                            Quantity Available
                                                      </th>
                                                      <th scope="col" className='grey-text'>
                                                            Qty Sold
                                                      </th>
                                                </tr>
                                          </thead>

                                          <tbody>
                                                {/* {itemHistory?.filter((x) => x.name.toLowerCase().includes(key.toLowerCase())).map(({ name, price, remQuantity, soldQuantity }, i) => { */}
                                                {topSell?.map(({ itemDetail, total_quantity }, i) => {

                                                      return (
                                                            <tr className='py-2' key={i}>
                                                                  <td className="text-start fw-bold">{itemDetail?.item}</td>
                                                                  <td className="text-start fw-bold">{naira}{0}</td>
                                                                  <td className=" ">{total_quantity}</td>
                                                                  <td className=" ">{0}</td>
                                                            </tr>
                                                      );
                                                })
                                                }
                                          </tbody>
                                    </table>
                              </div>
                        </div>
                  </div>


            </StyledTopSellingStock>
      );
};

export default TopSellingStock;

const StyledTopSellingStock = styled.div`
      


`;